/**
 * VerticalCardInfoContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

const VerticalCardInfoContainer = styled.div`
  position: absolute;
  top: ${4 * Screen.widthRatio}px;
  padding: ${8 * Screen.widthRatio}px;
  height: ${284 * Screen.widthRatio}px;
  width: ${184 * Screen.widthRatio}px;
`;

export default VerticalCardInfoContainer;
